





















import Vue from "vue";
import { Component } from "vue-property-decorator";
import { DashboardService } from "@/services/dashboard.service";

@Component({
})
export default class ProcessosFalhaCardSuporte extends Vue {
  totalProcessosEmFalha: number | null = null;
  loadingProcessosEmFalha = false;

  mounted() {
    this.CarregarProcessosEmFalha();
  }

  async CarregarProcessosEmFalha() {
    this.loadingProcessosEmFalha = true;
    this.totalProcessosEmFalha = await DashboardService.QuantidadeProcessosEmFalha().finally(
      () => (this.loadingProcessosEmFalha = false)
    );
  }
}
